<template>
  <View
    justify="center"
    align="center"
    flex-shrink="0"
    :class="['property-image-placeholder', size]"
    v-if="!imageUrl || isUnableToLoad"
  >
    <span v-if="!imageUrl">N/A</span>
    <Icon v-else name="image-x" />
  </View>

  <img v-else :class="['property-image', size]" @error="onError" :src="imageUrl" alt="Property image" />
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { Icon, View } from '@tallo/design-system';

defineProps<{ imageUrl: string | undefined; size: 'xs' | 'sm' | 'md' | 'lg' }>();

const isUnableToLoad = ref(false);

function onError() {
  isUnableToLoad.value = true;
}
</script>

<style scoped lang="scss">
$sizes: (
  'xs': '2rem',
  'sm': '3rem',
  'md': '5rem',
  'lg': '10rem',
);

.property-image-placeholder,
.property-image {
  width: var(--property-image-size);
  height: var(--property-image-size);
  border-radius: var(--t-border-radius-sm);

  @each $size, $value in $sizes {
    &.#{$size} {
      --property-image-size: #{$value};
    }
  }
}

.property-image-placeholder {
  background-color: var(--t-color-neutral-400);
  flex-shrink: 0;
}

.property-image {
  border-radius: var(--t-border-radius-sm);
  object-fit: cover;
}
</style>
